var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97694 22.9324C1.96013 22.9376 1.94543 22.9481 1.935 22.9623C1.92457 22.9765 1.91895 22.9937 1.91895 23.0113C1.91895 23.0289 1.92457 23.046 1.935 23.0602C1.94543 23.0744 1.96013 23.0849 1.97694 23.0901L8.48145 27.3864L10.3442 18.6211L1.97694 22.9324Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5234 18.6133H38.871C38.7695 18.6196 38.6701 18.645 38.5781 18.6884L30.316 22.9396C30.2409 22.9396 30.2334 23.0448 30.316 23.0973L36.7079 27.3035C36.7954 27.3526 36.8931 27.3809 36.9933 27.3861H38.6382C38.7283 27.3861 38.7358 27.3861 38.6382 27.3035L32.1036 23.0072L40.5234 18.6884C40.591 18.6508 40.5835 18.6133 40.5234 18.6133Z",
    fill: "#F08300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9707 18.6133H25.5014L23.6387 27.3861H35.0929C35.1831 27.3861 35.1906 27.3861 35.0929 27.3035L28.5734 23.0072L36.9481 18.6884C37.0683 18.6508 37.0608 18.6133 36.9707 18.6133Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.016 18.6133H42.3711C42.2694 18.6182 42.1697 18.6438 42.0782 18.6884L33.8161 22.9396C33.741 22.9396 33.741 23.0448 33.8161 23.0973L40.2154 27.3035C40.3 27.3533 40.3954 27.3817 40.4934 27.3861H42.1458C42.2284 27.3861 42.2434 27.3861 42.1458 27.3035L35.6187 23.0072L44.001 18.6884C44.1061 18.6508 44.0986 18.6133 44.016 18.6133Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4672 12.8748H9.48774C8.84575 12.8438 8.21318 13.0387 7.69998 13.4256C7.18678 13.8126 6.8254 14.3671 6.67864 14.9929C6.61199 15.2902 6.63331 15.6005 6.74001 15.8859C6.84671 16.1713 7.03417 16.4195 7.27952 16.6002L16.9762 22.9996L36.5048 12.9499C36.5573 12.9048 36.5498 12.8748 36.4672 12.8748Z",
    fill: "#E72511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1867 33.0422L16.9845 23L4.56882 29.4069C4.25524 29.5714 3.9792 29.7992 3.75813 30.0759C3.53706 30.3526 3.37576 30.6721 3.28443 31.0142C3.02906 32.1784 3.68252 33.1248 5.19223 33.1248H32.1717C32.2618 33.1248 32.2618 33.0872 32.1867 33.0422Z",
    fill: "#E72511"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1667,
    height: 20.2496,
    fill: "white",
    transform: "translate(1.91699 12.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/우체국-46.1c075387f298d276cda978b828aee85b.svg";
export { ForwardRef as ReactComponent };